import React from "react";

/** Presenters ------------------------------------------------- */
import { DoghnutChart } from "../../presenters";

/** Aux components -------------------------------------------- */
import ASSET_CLASSES from "../../asset-classes";
import DEFAULT_ALLOCATIONS from "../../default-allocations";

/**
 * The ProfileAllocation component displays default profiles
 * and the current portfolio allocation chose by the user
 *
 * @author Giovanna Marinelli
 */
const ProfileAllocation = ({
  allocation = DEFAULT_ALLOCATIONS["Agressiva"],
  onAllocationChange,
}) => {

  /**
   * Render the chart displaying the current
   * allocation
   */
  const renderAllocationChart = () => {
    const assetNotPandhora = Object.assign({}, ASSET_CLASSES);
    const allocationNotPandhora = Object.assign({}, allocation);
    const essencial = 'pandhoraEssencial';
    const lb = "pandhoraLb";

    delete assetNotPandhora[essencial];
    delete assetNotPandhora[lb];
    delete allocationNotPandhora[essencial];
    delete allocationNotPandhora[lb];

    const colors = Object.keys(assetNotPandhora).map(
      (k) => ASSET_CLASSES[k].color
    );
    const labels = Object.keys(assetNotPandhora).map((k) => assetNotPandhora[k].name);
    const values = Object.keys(allocationNotPandhora).map((k) => allocationNotPandhora[k]);
    return (
      <DoghnutChart
        options={{
          cutoutPercentage: 0,
          legend: {
            display: false,
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var labels = data.labels;
                var percentage = dataset.data[tooltipItem.index].toFixed(2);
                var label = labels[tooltipItem.index];
                return " " + label + ": " + percentage + "%  ";
              }
            }
          }

          // tooltips: {
          //   enabled: false,
          // },
        }}
        data={{
          datasets: [
            {
              data: values,
              backgroundColor: colors,
            },
          ],

          // These labels appear in the legend and in the tooltips when hovering different arcs
          labels: labels,
          backgroundColor: colors,
          text: values.reduce((prev, curr) => (prev += curr), 0.0) + "%",
        }}
      />
    );
  };

  /**
   * Render the Ok icon when allocation is 100%
   * 
   */
  const okLogo = (visibility, _allocationSum) => {
    return (
      <div className="allocationSum">
        <span className="allocationSumValue">{_allocationSum} %
        </span>
        <img
          className={`ProfileAllocation__ok-logo${visibility === "visible" ? "--visible" : ""
            }`}
          alt="n1"
          src={`${process.env.PUBLIC_URL}/img/check_icon.svg`}
        ></img></div>
    );
  };

  /**
   * Render the allocation value when less than 100%
   */
  const porcTo100 = (visibility, _allocationSum) => {
    return (
      <div className={`allocationSum${visibility === "visible" ? "--visible" : ""
        }`}>
        <span className="allocationSumValue">{_allocationSum} %</span>
      </div>
    );
  };

  // Allocation sum
  const allocationSum = Object.keys(allocation).reduce(
    (sum, key) => (sum += allocation[key]),
    0.0
  );

  return (
    <div className="ProfileAllocation">
      <div className="ProfileAllocation-portfolios">
        {renderAllocationChart()}
        <div className="ProfileAllocation__ok-logo-container">
          {allocationSum === 100.0 ? (
            okLogo("visible", allocationSum)
          ) : [allocationSum > 100.0 ? (
            <React.Fragment>
              <div style={{ color: "red" }}>
                {okLogo("hidden", allocationSum)} A alocação deve somar 100%
              </div>
            </React.Fragment>
          ) : [porcTo100("visible", allocationSum)]]}
        </div>
      </div>
    </div>
  );
};

export default ProfileAllocation;
